module.exports = __webpack_public_path__ + "img/theater3.3f11750e.jpg";